export const ICON_SPRITE_URL = window.orafol.ICON_SPRITE_URL || '/media/icons/icons.svg';

export const LANG = document.documentElement.lang || 'de';

export const BREAKPOINTS = {
  xs: '0px',
  s: '375px',
  m: '480px',
  l: '768px',
  xl: '990px',
  xxl: '1440px',
  xxxl: '1920px',
  navigation: '1070px',
};

export const MEDIA_QUERIES = {
  xs: '(min-width: 0px)',
  s: '(min-width: 375px)',
  m: '(min-width: 480px)',
  l: '(min-width: 768px)',
  xl: '(min-width: 990px)',
  xxl: '(min-width: 1440px)',
  xxxl: '(min-width: 1920px)',
  navigation: '(min-width: 1070px)',
};
